// removed by extract-text-webpack-plugin
module.exports = {"item":"MobileListBox__item__t0NPV","title":"MobileListBox__title__1P7Gr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileListBox/MobileListBox.scss
// module id = 398
// module chunks = 0